import { range, min, max, flattenDeep, uniq } from 'lodash-es'

const getRange = (dateTimeStart: string, dateTimeEnd: string) => {
  const year = dayJs(dateTimeStart)?.year()
  const startBeginningOfMonth = dayJs(dateTimeStart)?.startOf('month')
  const endEndOfMonth = dayJs(dateTimeEnd)?.endOf('month')
  return [startBeginningOfMonth, endEndOfMonth].filter(Boolean)
}

export const eventsGetStartOfMonths = (eventsData: array = [], year: number) => {
  let dateRangesEvents = eventsData?.map(entry => {
    const dateTimeRanges = entry?.attributes?.dateTimeRanges
    return dateTimeRanges?.map(dateTimeRange => {
      return getRange(dateTimeRange?.dateTimeStart, dateTimeRange?.dateTimeEnd)
    })
  })

  const dateRanges = flattenDeep(dateRangesEvents)?.sort((a, b) => {
    return a.format('YYYY-MM-DD') - b.format('YYYY-MM-DD')
  })

  const monthsForYear = uniq(dateRanges?.map(dateRange => {
    if (dateRange?.year() !== year) {
      return null
    }
    return dateRange?.startOf('month')?.format('YYYY-MM-DD')
  }))?.filter(Boolean)?.sort()

  return monthsForYear
}
